module.exports = __webpack_public_path__ + "static/media/ico-btn-microsoft.69d2b380.svg";